module.exports = __webpack_public_path__ + "static/logo_tena-d24bef879c0d697e8cda8d6e35155764.png";